import { render, staticRenderFns } from "./LimaconPascal.vue?vue&type=template&id=5a43a3fb&scoped=true&"
import script from "./LimaconPascal.vue?vue&type=script&lang=js&"
export * from "./LimaconPascal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a43a3fb",
  null
  
)

export default component.exports